// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"styles_image-wrapper__1hqg8","spin":"styles_spin__3yqEw","image":"styles_image__2cSqY"};